import { observable, action } from "mobx";
import { globalSensor } from "@/interface/sensor";
import { globalDbox } from "@/interface/dbox";
import { globalCamera } from "@/interface/camera";


class GlobalDeviceStore {
    @observable _globalSensors: globalSensor[] = [];
    @action globalSensors = (value: globalSensor[]) => {
        this._globalSensors = [...value];
    }

    @observable _globalDboxs: globalDbox[] = [];
    @action globalDboxs = (value: globalDbox[]) => {
        this._globalDboxs = [...value];
    }

    @observable _globalCameras: globalCamera[] = [];
    @action globalCameras = (value: globalCamera[]) => {
        this._globalCameras = [...value];
    }
}

export default GlobalDeviceStore;